<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-button
      type="text"
      icon="el-icon-s-tools"
      @click="openSendFormBuilderPriorityModal()"
      class="ml-1"
    >
      Configure
    </el-button>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <dialog-component
      :title="'Configure users and formbuilders'"
      :visible="openFormbuilderPriorityDialog"
      :containerWidth="'49%'"
      @before-close="resetSendFormBuilderPriorityDialog"
    >
      <div v-if="isFormbuilderMappingEdit">
        <el-scrollbar wrap-style="max-height: 60vh;">
          <div style="text-align: left">
            <el-collapse accordion>
              <el-collapse-item
                name="1"
                v-for="(localStep, i) in actionFormbuilderSteps"
                :key="i + '_step'"
                class="rule-collapse"
              >
                <template slot="title">
                  <div style="width: 100%" class="ml-1">
                    <label
                      v-if="localStep.type == 'TEMPLATE' && allTemplateFieldMap[localStep.template]"
                    >
                      <b>
                        {{ i + 1 }}.
                        {{ allTemplateFieldMap[localStep.template].name }}
                      </b>
                    </label>
                    <label v-if="localStep.type == 'ENTITY' && localStep.name">
                      <b>
                        {{ i + 1 }}.
                        {{ localStep.name }}
                      </b>
                    </label>
                  </div>
                </template>
                <!-- || e.type!= "CONTENT" -->
                <el-table
                  :data="
                    localStep.type == 'TEMPLATE' && allTemplateFieldMap[localStep.template]
                      ? allTemplateFieldMap[localStep.template].fields.filter(
                          (e) => ['FORMULA', 'SIGNATURE'].indexOf(e.input_type) === -1
                        )
                      : localStep.type == 'ENTITY'
                        ? getAllEntityFields(localStep.entity)
                        : []
                  "
                  size="mini"
                  border
                >
                  <el-table-column label="Field" prop="label" width="200">
                    <template slot-scope="{ row }">
                      <div style="font-weight: 500; font-size: 12px; color: #030503">
                        {{ row.label }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Mapped with" prop="key" width="250">
                    <template slot-scope="scope">
                      <div class="d-flex">
                        <el-select
                          v-model="
                            actionEntityPrimaryFieldsMap[
                              'mapped/' + localStep._id + '#' + scope.row.key
                            ]
                          "
                          placeholder="Update with"
                          clearable
                          filterable
                          :disabled="
                            actionEntityPrimaryFieldsMap[localStep._id + '#' + scope.row.key] &&
                            actionEntityPrimaryFieldsMap[localStep._id + '#' + scope.row.key].length
                              ? true
                              : false
                          "
                        >
                          <el-option
                            v-for="(field, i) in fetchTemplateFieldsByType(
                              [scope.row.inputType],
                              allCurrentEntityFields,
                              scope.row.entity_id,
                              scope.row.key
                            )"
                            :key="field + i"
                            :value="field.key"
                            :label="field.label"
                            :disabled="!!tableFieldDisabled(field)"
                          ></el-option>
                          <el-option
                            v-if="
                              scope.row.input_type == 'ENTITY' &&
                              scope.row.entity_id == currentEntity._id
                            "
                            :label="
                              'Current ' +
                              (currentEntity && currentEntity.name ? currentEntity.name : 'entity')
                            "
                            value="currentEntityData"
                          ></el-option>
                        </el-select>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Default value" prop="key" width="250">
                    <template slot-scope="scope">
                      <AnyFieldsExecute
                        v-if="
                          actionEntityPrimaryFieldsMap[
                            'mapped/' + localStep._id + '#' + scope.row.key
                          ]
                            ? false
                            : getFieldProperty(
                                  localStep.type == 'TEMPLATE' &&
                                    allTemplateFieldMap[localStep.template]
                                    ? allTemplateFieldMap[localStep.template].fields.filter(
                                        (e) =>
                                          ['FORMULA', 'SIGNATURE', 'DATA_TABLE'].indexOf(
                                            e.input_type
                                          ) === -1
                                      )
                                    : localStep.type == 'ENTITY'
                                      ? getAllEntityFields(localStep.entity)
                                      : [],
                                  scope.row.key,
                                  'key',
                                  '',
                                  {}
                                ).input_type == 'DATA_TABLE'
                              ? false
                              : true
                        "
                        :fieldsData="
                          localStep.type == 'TEMPLATE' && allTemplateFieldMap[localStep.template]
                            ? allTemplateFieldMap[localStep.template].fields.filter(
                                (e) =>
                                  ['FORMULA', 'SIGNATURE', 'DATA_TABLE'].indexOf(e.input_type) ===
                                  -1
                              )
                            : localStep.type == 'ENTITY'
                              ? getAllEntityFields(localStep.entity)
                              : []
                        "
                        :field="{
                          ...getFieldProperty(
                            localStep.type == 'TEMPLATE' && allTemplateFieldMap[localStep.template]
                              ? allTemplateFieldMap[localStep.template].fields.filter(
                                  (e) =>
                                    ['FORMULA', 'SIGNATURE', 'DATA_TABLE'].indexOf(e.input_type) ===
                                    -1
                                )
                              : localStep.type == 'ENTITY'
                                ? getAllEntityFields(localStep.entity)
                                : [],
                            scope.row.key,
                            'key',
                            '',
                            {}
                          ),
                          ...{
                            key: localStep._id + '#' + scope.row.key,
                          },
                        }"
                        :form="actionEntityPrimaryFieldsMap"
                      ></AnyFieldsExecute>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-scrollbar>
      </div>
      <div v-else>
        <el-row class="mt-1 mb-1">
          <el-col :span="12">
            <el-tooltip
              :content="
                is_enforce_order
                  ? 'You can drag and drop the cards to change order'
                  : 'Please click on add to configure'
              "
              v-if="is_enforce_order"
            >
              <el-tag type="primary" size="mini">
                <i class="el-icon-info"></i>
              </el-tag>
            </el-tooltip>
            <span class="warning" v-else>
              <i class="el-icon-info"></i>
              Please click on add to configure
            </span>
          </el-col>
          <el-col :span="3" :offset="4">
            <el-checkbox
              v-if="entity_formbuilder_configurations.length > 1"
              v-model="is_enforce_order"
            >
              Enforce order
            </el-checkbox>
          </el-col>
          <el-col :span="3" :offset="2">
            <el-button type="primary" @click="addNewFormbuilderEntityConfig" size="mini">
              Add
              <i class="el-icon-circle-plus-outline"></i>
            </el-button>
          </el-col>
          <el-col :span="3" :offset="2">
            <el-button type="text" @click="openFormMailConfigurationDialog">
              <i class="el-icon-setting"></i>
              Configure the email
            </el-button>
          </el-col>
        </el-row>
        <draggable v-model="entity_formbuilder_configurations" group="rows" @end="onDragEnd">
          <div v-for="(row, index) in entity_formbuilder_configurations" :key="index" class="mb-1">
            <div class="custom-card">
              <span class="number-highlight">{{ index + 1 + '.' }}</span>
              <el-tooltip
                content="Select the user whom you want to send the form builder(receiver)"
                placement="top"
              >
                <el-select
                  v-model="row.selected_entity"
                  placeholder="Send to"
                  @change="(changedValue) => getEntityDetails(changedValue, localStep)"
                  clearable
                  filterable
                >
                  <el-option-group label="Entity fields">
                    <el-option
                      v-for="(field, i) in getUserEntities(
                        getFieldsByType(['ENTITY'], allFieldsWithDataTable)
                      )"
                      :key="field + i"
                      :value="field.entity_id + '#' + field.key"
                      :label="field.label"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </el-tooltip>
              <el-select
                v-model="row.formbuilder_id"
                placeholder="Select form builder"
                clearable
                filterable
              >
                <el-option
                  v-for="(field, i) in getFormbuildersRelated(row.selected_entity, allFields)"
                  :key="field + i"
                  :value="field._id"
                  :label="field.name"
                ></el-option>
              </el-select>
              <el-tooltip
                content="Map current entity field values to the selected form builder fields"
                placement="top"
              >
                <el-button
                  @click="openFormbuilderPrimaryFieldsModal(row, index)"
                  type="text"
                  class="ml-1"
                >
                  Map values
                  <i class="el-icon-info"></i>
                </el-button>
              </el-tooltip>
              <el-link
                @click="removeFormbuilderData(index)"
                type="danger"
                :underline="false"
                class="ml-1"
              >
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </div>
        </draggable>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="isFormbuilderMappingEdit" @click="saveMappingFields" type="primary">
          Save & Go Back
        </el-button>
        <el-button @click="resetSendFormBuilderPriorityDialog" v-if="!isFormbuilderMappingEdit">
          Close
        </el-button>
        <el-button
          v-if="!isFormbuilderMappingEdit"
          type="primary"
          @click="saveFormPriorityConfiguration"
          :disabled="!!checkAllConfigured"
        >
          Save Changes
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      :title="'Configure the email'"
      :visible="openFormMailConfig"
      :isShowFooter="true"
      :containerWidth="'55%'"
      :containerHeight="'75%'"
      @before-close="closeFormMailConfig"
    >
      <div class="p-4">
        <span style="font-weight: bold">Filling button name</span>
        <el-input
          v-model="formbuilder_mail_configuration.button_name"
          placeholder="Enter button name"
          class="mb-1"
        ></el-input>

        <span style="font-weight: bold">Subject</span>
        <el-input
          v-model="formbuilder_mail_configuration.subject"
          placeholder="Enter subject"
          class="mb-1"
        ></el-input>

        <span style="font-weight: bold">Custom Message</span>
        <CkEditorOffline
          v-model="formbuilder_mail_configuration.body"
          :config="editorConfig4"
        ></CkEditorOffline>

        <div
          @click="chooseFromParentEmailTemplates('SEND_FORM_MAIL')"
          style="cursor: pointer; color: #409eff; margin-left: 200px"
        >
          <span v-if="!formbuilder_mail_configuration.name">
            Choose Parent Template (Header & Footer)
          </span>
          <span v-else>Change Parent Template (Header & Footer)</span>
        </div>

        <div v-if="formbuilder_mail_configuration.name" class="mb-2" style="margin-left: 200px">
          Selected Parent:
          <span>{{ formbuilder_mail_configuration.name }}</span>
          <span>
            <i style="cursor: pointer" @click="resetParent" class="el-icon-error"></i>
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateFormMailConfiguration">
          <i class="el-icon-finished"></i>
          <span>Save</span>
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      title="Parent Templates(Header Footer)"
      :visible.sync="emailTemplatesParentListDialog"
      :show-close="true"
      :isShowFooter="false"
      :containerMaxWidth="'70%'"
      :containerMinWidth="'80%'"
    >
      <div
        v-if="
          editForm &&
          emailTemplatesParentListType == 'APPROVE_USER' &&
          editForm.approval_notify_settings &&
          editForm.approval_notify_settings.mail_template_data
        "
      >
        <singleEntityTemplatesList
          :content="editForm.approval_notify_settings.mail_template_data"
          :entity_id="currentEntity._id"
          type="PARENT"
          v-on:closeDialog="closeEmailFooter"
        />
      </div>
      <div
        v-else-if="
          editForm &&
          emailTemplatesParentListType == 'DECLINE_USER' &&
          editForm.decline_notify_settings &&
          editForm.decline_notify_settings.mail_template_data
        "
      >
        <singleEntityTemplatesList
          :content="editForm.decline_notify_settings.mail_template_data"
          :entity_id="currentEntity._id"
          type="PARENT"
          v-on:closeDialog="closeEmailFooter"
        />
      </div>
      <div
        v-else-if="
          editForm && editForm.approval_settings && editForm.approval_settings.mail_template_data
        "
      >
        <singleEntityTemplatesList
          :content="editForm.approval_settings.mail_template_data"
          :entity_id="currentEntity._id"
          type="PARENT"
          v-on:closeDialog="closeEmailFooter"
        />
      </div>
      <div
        v-else-if="
          formbuilder_mail_configuration && emailTemplatesParentListType == 'SEND_FORM_MAIL'
        "
      >
        <singleEntityTemplatesList
          :content="formbuilder_mail_configuration"
          :entity_id="currentEntity._id"
          type="PARENT"
          v-on:closeDialog="closeEmailFooter"
        />
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import { mapMailTemplateVariables } from '../actionHelper';
  import StepEditableMixin from './StepEditableMixin';
  import templateBuilderHelper from '../../../../mixins/templateBuilderHelper';
  import { ckEditorConfig } from '@/assets/data/ckeditor_config.ts';
  import draggable from 'vuedraggable';
  export default {
    name: 'SendFormBuilderAction',
    props: {
      step: Object,
      currentEntity: Object,
      allEntities: Array,
      allFormbuilders: Array,
      allTemplateFieldMap: Object,
      allFields: Array,
    },
    mixins: [StepEditableMixin, templateBuilderHelper],
    mounted() {
      this.allFieldsWithDataTable = this.getAllFieldsFromEntity(
        this.currentEntity,
        true,
        true,
        true
      );
      this.allCurrentEntityFields = this.getAllFieldsFromEntity(
        this.currentEntity,
        false,
        false,
        true
      );
      (this.allEntities || []).forEach((entity) => {
        this.actionEntityFields[entity._id] = this.getAllFieldsFromEntity(
          entity,
          false,
          false,
          true
        );
      });
      this.configCKeditor();
    },
    components: {
      CkEditorOffline: () => import('@/components/CkEditor.vue'),
      singleEntityTemplatesList: () =>
        import('@/components/emailTemplates/singleEntityTemplatesList.vue'),
      draggable,
      AnyFieldsExecute: () =>
        import('@/components/templates/formComponentsExecute/AnyFieldsExecute.vue'),
    },
    data() {
      return {
        editorConfig: JSON.parse(JSON.stringify(ckEditorConfig)),
        mappingIndex: -1,
        entity_formbuilder_configurations: [],
        is_enforce_order: false,
        emailTemplatesParentListType: 'APPROVER',
        openFormbuilderPriorityDialog: false,
        isFormbuilderMappingEdit: false,
        openFormMailConfig: false,
        emailTemplatesParentListDialog: false,
        editForm: {},
        allFieldsWithDataTable: [],
        actionEntityPrimaryFieldsMap: {},
        mapFieldsToFormbuilderModel: false,
        dataTableConfigObject: {},
        editorConfig1: {},
        editorConfig2: {},
        editorConfig3: {},
        editorConfig4: {},
        allCurrentEntityFields: [],
        formbuilder_mail_configuration: {
          subject: 'Please verify to fill the form',
          body: '<p>Hello,</p>\n\n<p>You are requested to fill the form.</p>\n\n<p>Thank you.</p>\n',
          cc_user: [],
          header_body: '',
          footer_body: '',
          name: '',
          button_name: 'Start Filling',
        },
      };
    },
    methods: {
      openSendFormBuilderPriorityModal() {
        this.entity_formbuilder_configurations =
          this.localStep?.entity_formbuilder_configurations || [];
        this.formbuilder_mail_configuration = this.localStep?.formbuilder_mail_configuration;
        if (!this.formbuilder_mail_configuration && !this.formbuilder_mail_configuration?.body) {
          this.formbuilder_mail_configuration = {
            subject: 'Please verify to fill the form',
            body: '<p>Hello,</p>\n\n<p>You are requested to fill the form.</p>\n\n<p>Thank you.</p>\n',
            cc_user: [],
            header_body: '',
            footer_body: '',
            name: '',
            button_name: 'Start Filling',
          };
        }
        this.formbuilder_mail_configuration.body = mapMailTemplateVariables(
          this.formbuilder_mail_configuration.body,
          true,
          true
        );
        this.is_enforce_order = this.localStep.is_enforce_order;
        this.openFormbuilderPriorityDialog = true;
        this.emailTemplatesParentListType = 'SEND_FORM_MAIL';
      },
      resetSendFormBuilderPriorityDialog() {
        this.openFormbuilderPriorityDialog = false;
        this.isFormbuilderMappingEdit = false;
      },
      openFormMailConfigurationDialog() {
        this.openFormMailConfig = true;
      },
      closeFormMailConfig() {
        this.openFormMailConfig = false;
      },
      chooseFromParentEmailTemplates(type) {
        this.emailTemplatesParentListType = type;
        this.emailTemplatesParentListDialog = true;
      },
      closeEmailFooter() {
        this.emailTemplatesParentListDialog = false;
      },
      updateFormMailConfiguration() {
        if (this.formbuilder_mail_configuration?.body) {
          this.formbuilder_mail_configuration.body = mapMailTemplateVariables(
            this.formbuilder_mail_configuration.body,
            false,
            true
          );
        }
        this.saveFormPriorityConfiguration();
        this.openFormMailConfig = false;
      },
      saveFormPriorityConfiguration() {
        this.$set(
          this.localStep,
          'entity_formbuilder_configurations',
          this.entity_formbuilder_configurations
        );
        this.$set(
          this.localStep,
          'formbuilder_mail_configuration',
          this.formbuilder_mail_configuration
        );
        this.$set(this.localStep, 'is_enforce_order', this.is_enforce_order);
      },
      onDragEnd(evt) {
        //need to check use of this evt
        console.log('Drag ended', evt);
        this.saveOrder();
      },
      saveOrder() {
        this.entity_formbuilder_configurations.forEach((config, index) => {
          config.order = index + 1;
        });
      },
      tableFieldDisabled(field) {
        if (
          field.data_table_field_index &&
          field.data_table_field_index > -1 &&
          Object.keys(this.actionEntityPrimaryFieldsMap).find((e) => e.includes('relation/')) !==
            undefined
        ) {
          return true;
        } else {
          return false;
        }
      },
      checkAllConfigured() {
        if (this.entity_formbuilder_configurations.length === 0) {
          return true;
        } else if (this.entity_formbuilder_configurations.length > 0) {
          for (const config of this.entity_formbuilder_configurations) {
            if (!config.selected_entity || !config.formbuilder_id) {
              return true;
            }
          }
        }
        return false;
      },
      configCKeditor() {
        this.editorConfig.mentions = [
          {
            feed: this.dataFeed,
            itemTemplate:
              '<li data-id="{id}">' + '<strong class="label">{label}</strong>' + '</li>',
            outputTemplate: '<span>&nbsp;</span><span>[[{label}]]</span><span>&nbsp;</span>',
            minChars: 0,
            convertTo: function (item) {
              return {
                template_key: item.label,
              };
            },
          },
          {
            feed: '/tags?name={encodedQuery}',
            marker: '#',
          },
        ];
        this.editorConfig1 = {
          ...this.editorConfig,
          id: 'approval_settings',
        };
        this.editorConfig2 = {
          ...this.editorConfig,
          id: 'approval_notify_settings',
        };
        this.editorConfig3 = {
          ...this.editorConfig,
          id: 'decline_notify_settings',
        };
        this.editorConfig4 = {
          ...this.editorConfig,
          id: 'formbuilder_notify_mail',
        };
      },
      resetParent() {
        switch (this.emailTemplatesParentListType) {
          case 'APPROVER':
            if (this.editForm?.approval_settings?.mail_template_data) {
              this.editForm.approval_settings.mail_template_data.footer_body = '';
              this.editForm.approval_settings.mail_template_data.header_body = '';
              this.editForm.approval_settings.mail_template_data.name = '';
            }
            break;
          case 'APPROVE_USER':
            if (this.editForm?.approval_notify_settings?.mail_template_data) {
              this.editForm.approval_notify_settings.mail_template_data.footer_body = '';
              this.editForm.approval_notify_settings.mail_template_data.header_body = '';
              this.editForm.approval_notify_settings.mail_template_data.name = '';
            }
            break;
          case 'DECLINE_USER':
            if (this.editForm?.decline_notify_settings?.mail_template_data) {
              this.editForm.decline_notify_settings.mail_template_data.footer_body = '';
              this.editForm.decline_notify_settings.mail_template_data.header_body = '';
              this.editForm.decline_notify_settings.mail_template_data.name = '';
            }
            break;
          case 'SEND_FORM_MAIL':
            if (this.formbuilder_mail_configuration) {
              this.formbuilder_mail_configuration.footer_body = '';
              this.formbuilder_mail_configuration.header_body = '';
              this.formbuilder_mail_configuration.name = '';
            }
            break;
        }
      },
    },
  };
</script>
<style scoped>
  .action-config-item {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    font-family:
      'Inter',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
    font-size: 13px;
  }

  .ml-1 {
    margin-left: 0.5rem;
  }

  .custom-card {
    background-color: #f9fafb;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
  }

  .number-highlight {
    font-weight: 600;
    color: #2563eb;
    min-width: 20px;
  }

  .el-button {
    border-radius: 6px;
    font-weight: 500;
    font-size: 13px;
    padding: 4px 10px;
  }

  .el-button i {
    margin-right: 4px;
  }

  .el-select {
    width: 100%;
    font-size: 13px;
    border-radius: 6px;
  }

  .el-select .el-input__inner {
    padding: 0.35rem 0.75rem;
  }

  .el-option:hover {
    background-color: #eff6ff;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    padding: 12px 0;
  }

  .rule-collapse {
    background-color: #fefefe;
    border-radius: 6px;
    margin-bottom: 0.5rem;
    border: 1px solid #e5e7eb;
  }

  .el-table {
    font-size: 12px;
  }

  .el-table th {
    background-color: #f3f4f6;
    font-weight: 600;
    color: #111827;
  }

  .el-table .el-table__body tr:hover {
    background-color: #f3f4f6;
  }

  .el-tooltip .el-tooltip__popper {
    font-size: 12px;
  }

  .el-collapse-item__header {
    font-weight: 500;
    font-size: 14px;
    color: #111827;
  }

  .el-tag {
    font-size: 12px;
    padding: 2px 6px;
  }

  .warning {
    font-size: 12px;
    color: #b91c1c;
  }

  .draggable-placeholder {
    background-color: #e0e7ff;
    border: 1px dashed #2563eb;
    min-height: 40px;
  }

  .ck-editor__editable_inline {
    min-height: 120px;
    border-radius: 6px;
    padding: 0.5rem;
  }

  .el-link i {
    font-size: 14px;
    vertical-align: middle;
    color: #ef4444;
    cursor: pointer;
  }

  .popUp-content {
    padding: 1rem;
    background-color: #f9fafb;
    border-radius: 8px;
  }
</style>
